import type { InputConfig } from "@smartsuite/automation-engine-api";
import { SwitchButton } from "@smartsuite/react-ui/lib";
import { useEffect, useState } from "react";
import { stylesSwitchButtonRect } from "../InputSelectStyles";
import { translateIfPresent } from "../../../../../../locales/i18n";

export const ToggleType: React.FC<{
  options: Array<{
    value: string;
    label: string;
  }>;
  config: InputConfig;
  onChange: (input: InputConfig) => void;
}> = ({ options, config, onChange }) => {
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    if (
      config.value?.values[0]?.value.oneofKind === "string" &&
      config.value?.values[0]?.value.string !== ""
    ) {
      setSelectedOption(config.value?.values[0]?.value.string);
    } else {
      // Set default value if not set
      onChange({
        ...config,
        value: {
          values: [
            {
              value: {
                oneofKind: "string",
                string: options[0].value,
              },
            },
          ],
        },
      });
    }
  }, [config]);

  return (
    <SwitchButton
      options={options.map((option) => ({
        value: option.value,
        label: translateIfPresent("caption." + option.label, option.label),
      }))}
      currentValue={selectedOption ?? ""}
      styles={stylesSwitchButtonRect}
      onChange={(value) => {
        onChange({
          ...config,
          value: {
            values: [
              {
                value: {
                  oneofKind: "string",
                  string: String(value),
                },
              },
            ],
          },
        });
      }}
    />
  );
};
